import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllAuditLogs } from '../../store/actions';
import { GenCustomTable } from '../../components/customComponents/genCustomTable/GenCustomTable';
import Header from '../../components/layout/Header';
import Badge from '../../components/ui/Badge';
import { AUDIT_ENTITY_TYPES } from '../AuditLog/AuditLog';
import { USER_ROLE, label } from '../../constants/garmentCodes';

const stateText = (state) => {
  if (state == null) return '—';
  if (typeof state !== 'object') return String(state);
  return Object.entries(state).map(([k, v]) => `${k}: ${v}`).join(', ');
};

export default function BrandAudit() {
  const dispatch = useDispatch();
  const [entityType, setEntityType] = useState('');
  const logs = useSelector((state) => state.auditlog.logs);
  const loading = useSelector((state) => state.auditlog.loading);

  useEffect(() => {
    dispatch(getAllAuditLogs({ entityType }));
  }, [dispatch, entityType]);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <Header title="Audit History" subtitle={`${logs.length} events`} />
      <div className="flex-1 overflow-y-auto p-6 space-y-4">
        <div className="flex gap-2 flex-wrap items-center">
          {['', ...AUDIT_ENTITY_TYPES].map((e) => (
            <button key={e || 'all'} onClick={() => setEntityType(e)} className={`px-3 py-1.5 text-xs font-medium rounded-lg border transition-colors ${entityType === e ? 'bg-[#1E2A3B] text-white border-transparent' : 'bg-white text-[#5C5A54] border-[#E5E3DE] hover:bg-[#F4F3F0]'}`}>
              {e || 'All events'}
            </button>
          ))}
          {loading && <span className="text-xs text-[#9B9893]">Loading…</span>}
        </div>

        <div className="bg-white rounded-xl border border-[#E5E3DE] overflow-hidden [&_.MuiTablePagination-toolbar]:!justify-end [&_.MuiTablePagination-spacer]:!flex-1 [&_.MuiTablePagination-spacer]:!block [&_.MuiTablePagination-selectLabel]:!m-0 [&_.MuiTablePagination-displayedRows]:!m-0 [&_.MuiTablePagination-root]:!text-[#5C5A54]">
          <GenCustomTable
            isExportEnabled={true}
            exportFileName="BrandAudit"
            columns={[
              { id: 'user', label: 'USER', align: 'left' },
              { id: 'action', label: 'ACTION', align: 'left' },
              { id: 'entity', label: 'ENTITY', align: 'left' },
              { id: 'summary', label: 'SUMMARY', align: 'left', minWidth: 220 },
              { id: 'change', label: 'CHANGE', align: 'left', minWidth: 200 },
            ]}
            rows={logs.map((ev) => ({
              id: ev.id,
              rColumns: [
                <div key="u" label={ev.userName || ''} className="flex flex-col justify-center w-full h-full px-2 py-1">
                  <p className="text-sm font-medium text-[#1A1915]">{ev.userName || 'System'}</p>
                  <p className="text-[10px] text-[#9B9893]">{label(USER_ROLE, ev.role, '')}</p>
                </div>,
                <div key="a" label={ev.action || ''} className="flex items-center w-full h-full px-2 py-1 text-xs font-medium text-[#1A1915]">{ev.action || '—'}</div>,
                <div key="e" label={ev.entityType || ''} className="flex items-center gap-1.5 w-full h-full px-2 py-1">
                  {ev.entityType && <Badge variant="gray">{ev.entityType}</Badge>}
                  {ev.entityId != null && <span className="font-mono text-[10px] text-[#3D52A0]">#{ev.entityId}</span>}
                </div>,
                <div key="s" label={ev.summary || ''} className="flex items-center w-full h-full px-2 py-1 text-xs text-[#5C5A54]">{ev.summary || '—'}</div>,
                <div key="c" label={`${stateText(ev.beforeState)} → ${stateText(ev.afterState)}`} className="flex flex-col justify-center w-full h-full px-2 py-1 text-[10px] font-mono">
                  <span className="text-[#C0222B]">{stateText(ev.beforeState)}</span>
                  <span className="text-[#1A6B3E]">{stateText(ev.afterState)}</span>
                </div>,
              ],
            }))}
          />
          {!loading && logs.length === 0 && <p className="py-10 text-center text-sm text-[#9B9893]">No audit events</p>}
        </div>
      </div>
    </div>
  );
}
